<template>
  <v-container fluid>
    <v-card flat>
      <v-card-actions class="pa-2">
        <search-bar></search-bar>
      </v-card-actions>
    </v-card>
    <template v-if="results.length > 0">
      <v-subheader>{{ results.length }}件が見つかりました。</v-subheader>
      <v-layout row wrap>
        <v-flex xs12>
          <sorter @sort="sortByUser" />
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <template v-for="(graph, index) in results">
            <graph-card :key="index" :payload="graph"></graph-card>
            <v-divider v-if="index < results.length - 1" :key="'divider' + index" class="divider"></v-divider>
          </template>
        </v-flex>
      </v-layout>
    </template>

    <v-card flat v-else>
      <not-found>検索結果は見つかりませんでした</not-found>
    </v-card>
  </v-container>
</template>
<script>
import GraphCard from "@/views/home/GraphCard.vue";
import SearchBar from "@/components/SearchBar.vue";
import NotFound from "@/components/parts/404.vue";
import Sorter from "@/components/Sorter.vue";

export default {
  components: { 
    GraphCard,
    SearchBar,
    NotFound,
    Sorter
  },
  computed: {
    results() {
      return this.$store.getters.getSearchResult;
    }
  },
  methods: {
    sortByUser(sortKey, order) {
      this.results.sort((a, b) => {
        return (a[sortKey] - b[sortKey]) * order;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.divider {
  width: 100%;
  margin: 20px 0;
  border: none;
  border-top: dashed 1px #FF9933;
}
</style>

